import { FlingBonusPrizeTier } from "components/bonus/fling/fowl-fling-bonus-component";
import { BonusResult } from "slotworks/model/gameplay/records/results/bonus-result";

export class FowlJackpotBonusResult extends BonusResult {
    public resultType: string = "FowlJackpotBonusResult";

    public tier: FlingBonusPrizeTier;
}
